import {
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';

const InfoContent = ({ onClose, onAgree, askFor }) => {
  const intl = useIntl();
  const i18n = translations.MatchMakingV2(intl).Dialog.info;
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Stack gap={'25px'}>
      <Stack gap={'5px'}>
        <Typography
          variant={'m-bold'}
          textAlign={isSmDown ? 'start' : 'center'}
        >
          {i18n[askFor].title}
        </Typography>
        <Typography variant={'body2'} textAlign={isSmDown ? 'start' : 'center'}>
          {i18n[askFor].subOne} <br /> <br />
          {i18n[askFor].subTwo}
        </Typography>
      </Stack>
      <Stack
        flexDirection={isSmDown ? 'column-reverse' : 'row'}
        gap={isSmDown ? '20px' : '25px'}
        justifyContent={'center'}
      >
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={onClose}
        >
          {i18n.buttons.cancel}
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => onAgree()}
        >
          {i18n.buttons.send}
        </Button>
      </Stack>
    </Stack>
  );
};
export default InfoContent;
